module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Nick Zamfir is the founder and president of Abiding in Christ Ministries based in Orlando, Florida.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Zamfir has a bachelor’s degree in theology from Babes-Bolyai University, Cluj-Napoca, Romania, and has a minor in marriage counselling. He and his wife, Doina, have been married for 33 years and have a 31-year-old son, Alin, and a 27-year-old daughter, Kristina. They have lived in the Orlando for the past 14 years.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("After accumulating writing experience as a religious columnist for a newspaper, Nick is now writing his fifth book. He also preaches, authors textbooks, and teaches in a school of ministry, and is in his final preparation for an Internet-based television ministry focused on positive, life-changing programs for youth and young adults, and for the non-professing Christian community.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0